import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Container, Grid } from "@material-ui/core";
import { greyVelvet } from "../../../assets/img/bg";
import { defaultBg } from "../../../assets/img/articles";
import PageBackground from "../../organisms/PageBackground";
import { PageHeroBanner } from "../../organisms/HeroBanner";
import PillarButtonContainer from "../../organisms/PillarButtonContainer/PillarButtonContainer";
import InfiniteScrollArticleCards from "../../organisms/InfiniteScrollArticleCards";
import { useUserPastAndCurrentProgrammes } from "../../hooks/useUserPastAndCurrentProgrammes";
import "./Articles.scss";

const Articles = () => {
  const [tags, setTags] = useState({ pillars: [], publicTags: [] });
  const [userPastAndCurrentProgrammes, userPastAndCurrentProgrammesReady] = useUserPastAndCurrentProgrammes();

  useEffect(() => {
    if (userPastAndCurrentProgrammesReady) {    
      const pillars = userPastAndCurrentProgrammes
        .flatMap((x) => x.pillars)
        .filter(
          (p, index, array) =>
            array.findIndex((m) => m.displayName === p.displayName && m.tag === p.tag) === index
        );
      const publicTags = userPastAndCurrentProgrammes.map((p) => p.tag);
      setTags({ pillars, publicTags });
    }
  }, [userPastAndCurrentProgrammes, userPastAndCurrentProgrammesReady]);

  return (
    <PageBackground bgImage={greyVelvet}>
      <Helmet>
        <title>Latest articles | Gloji</title>
      </Helmet>
      <div className="articles-page">
        <PageHeroBanner bgImg={defaultBg}>
          <div className="articles-banner__header">
            <h1 className="articles-banner__heading">Articles</h1>
            <h2 className="articles-banner__subheading">What would you like to explore?</h2>
          </div>

          {userPastAndCurrentProgrammesReady && (
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <PillarButtonContainer pillars={tags.pillars} />
            </Grid>
          )}
        </PageHeroBanner>

        <Container className="main-content__container articles-content">
          {userPastAndCurrentProgrammesReady && (
            <InfiniteScrollArticleCards
              pillarTags={tags.pillars.map((p) => p.tag)}
              publicTags={tags.publicTags}
            />
          )}
        </Container>
      </div>
    </PageBackground>
  );
};

export default Articles;
